<template>
  <div id="handContent">
    <div id="cards" >
        <Card cardId="duca" v-if="hasTook"/>
        <draggable class="draggable" @start="drag=true" @end="drag=false"  v-bind="{group:'cards'}" v-model="cards" :move="movedCard" @remove="setCardOnTable" :forceFallback="true"> 
          <Card :class="{ 'isMyTurn': isMyTurn && callSection == 'finished' }" class="card" v-for="card in cards" v-bind:key="card" :cardId="card"/>
        </draggable>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Card from "@/components/Card";
import draggable from 'vuedraggable';

export default {
  name: "Hand",
  components: {
    Card, 
    draggable
  },
  computed: {
    ...mapState({
      cards: state => {
        return state.game.cards;
      },
      took: state => {
        return state.game.players[0].took;
      }
    }),
    ...mapGetters({
      myPlayedCard: "game/myPlayedCard",
      isMyTurn: "game/isMyTurn",
      callSection: "call/callSection",
      hasTook: "game/hasTook"
    }),
    cards: {
      get() {
				return this.$store.state.game.cards
			},
      set(value) {
        this.$store.commit("game/setMyCards", value)
      }
    }
  },
  methods: {
    movedCard(event) {
      if(event.from != event.to) {
        return !!this.isMyTurn 
               && !this.myPlayedCard;
      }
    },
    setCardOnTable(event) {
      this.$store.commit("game/setCardOnTable", {card: event.item.id})
    }
  }
};
</script>
<style scoped>
#cards {
    display: flex;
    justify-content: center;
}
.draggable {
    display: flex;
    align-items: center;
    justify-content: center;
    width: -webkit-fill-available;
}

@keyframes blink { 
   50% { 
    border: 7px dashed lightseagreen;
    border-radius: 25px; 
    } 
}
.isMyTurn{
    animation-name: blink ;
    animation-duration: .5s ;
    animation-timing-function: step-end ;
    animation-iteration-count: infinite ;
    animation-direction: alternate ;
    display: inline-table;
    border: 7px dashed rgba(32, 178, 170, 0);
}
</style>
